import React, {useCallback} from 'react';

import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';
import {useUserEmail} from 'src/hooks/useUserEmail';
import {getUser} from 'src/modules/admin/services';
import {printSheetHeader, printTableData, printTableDataHeader} from 'src/modules/attributes/download/print-data';
import {Filters} from 'src/modules/attributes/typedefs';
import {Download} from 'src/modules/downloads/download';
import {getUserName} from 'src/modules/downloads/utils/get-user-name';
import {AttributeRelationInfo} from 'src/openapi/models/AttributeRelationInfo';
import {useAppSelector} from 'src/store';

import {formatDate} from '@pb/kit-formatters';

type Props = {
    filters: Filters,
    attributes: Array<AttributeRelationInfo>,
};

export const AttributesExcelDownload = ({filters, attributes}: Props) => {
    const user = useAppSelector(getUser);
    const userEmail = useUserEmail();
    const userName = getUserName(userEmail, user);

    const onDownload = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Attributes', {views: [{showGridLines: false}]});

        printSheetHeader(worksheet, userName, filters);
        printTableDataHeader(worksheet);
        printTableData(worksheet, attributes);

        const buffer = await workbook.xlsx.writeBuffer();
        const date = formatDate(new Date(), 'YYYY_DD_MM_H_mm_ss');

        saveAs(new Blob([buffer]), `UD_Design_Tool_Attributes_${date}.xlsx`);
    }, [attributes, filters, userName]);

    return (
        <Download onDownload={onDownload}/>
    );
};
